import { render, staticRenderFns } from "./Gemini.vue?vue&type=template&id=8cea0d28&"
import script from "./Gemini.vue?vue&type=script&lang=js&"
export * from "./Gemini.vue?vue&type=script&lang=js&"
import style0 from "./Gemini.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports